import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { DownloadListState } from './download-list.reducer';
import * as DownloadListAction from './download-list.actions';

const DOWNLOAD_LIST_KEY = 'downloadList';

export function hydrationMetaReducer(reducer: ActionReducer<DownloadListState>): ActionReducer<DownloadListState> {
  return (state, action) => {
    //Init/update local storage
    if (action.type === INIT || action.type === UPDATE) {
      try {
        const stored = localStorage.getItem(DOWNLOAD_LIST_KEY);
        if (stored) {
          const parsedDownloadList = JSON.parse(stored);
          const hydratedState: DownloadListState = {
            downloadList: parsedDownloadList,
            isDownloadListActive: state?.isDownloadListActive ?? false,
          };
          return reducer(hydratedState, action);
        }
      } catch (e) {
        console.warn('Hydration error', e);
      }
    }

    //Clear local storage
    if (action.type === DownloadListAction.clearDownloadList.type) {
      try {
        localStorage.removeItem(DOWNLOAD_LIST_KEY);
      } catch (e) {
        console.warn('Failed to remove from localStorage', e);
      }
    }

    const nextState = reducer(state, action);

    // Don't save to localStorage if this is a sync from another tab
    // (to avoid circular updates)
    if (action.type !== DownloadListAction.syncDownloadListFromStorage.type) {
      try {
        localStorage.setItem(DOWNLOAD_LIST_KEY, JSON.stringify(nextState.downloadList));
      } catch (e) {
        console.warn('Storage error', e);
      }
    }

    return nextState;
  };
}
